const ADD_WEBSOCKET_CONEXION = 'ADD_WEBSOCKET_CONEXION';
const REMOVE_WEBSOCKET_CONEXION = 'REMOVE_WEBSOCKET_CONEXION';

export const addWebSocketConexion = webSocketConexion => ({
    type: ADD_WEBSOCKET_CONEXION,
    webSocketConexion
});

export const removeWebSocketConexion = webSocketConexion => ({
    type: REMOVE_WEBSOCKET_CONEXION,
    webSocketConexion
});

const addWebSocket = (webSocketsList, newWebSocked) => {
    webSocketsList.push(newWebSocked);

    return webSocketsList;
};

const removeWebSocket = (webSocketList, removedWebSocked) => webSocketList.filter(socket => socket.id !== removedWebSocked.id);

const _defaultState = () => ({
    webSockets: []
});


export const reducer = (state = _defaultState(), action = '') => {
    switch (action.type) {
    case ADD_WEBSOCKET_CONEXION:
        return {
            ...state,
            webSockets: addWebSocket(state.webSockets, action.webSocketConexion)
        };
    case REMOVE_WEBSOCKET_CONEXION:
        return {
            ...state,
            webSockets: removeWebSocket(state.webSockets, action.webSocketConexion)
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/websockets.js